import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import emailIcon from "../../assets/verified.png";
import LoadingOverlay from "../Dashboard/Common/LoadingOverlay";

const ConfirmEmail = () => {
  const apiUrl = process.env.REACT_APP_API_URL;
  const { confirmationCode } = useParams();
  const [status, setStatus] = useState("");
  const [isLoading, setIsLoading] = useState(true);
  const navigate = useNavigate();
  useEffect(() => {
    if (confirmationCode) {
      verifyEmail(confirmationCode);
    }
  }, [confirmationCode]);

  const verifyEmail = async (code) => {
    try {
      setIsLoading(true);
      const response = await fetch(
        `${apiUrl}/auth:confirm_email?confirimation_code=${code}`
      );
      if (response.ok) {
        setStatus("Email Verified. Please log in.");
      } else {
        setStatus("Verification failed. Please try again.");
      }
    } catch (error) {
      setStatus("An error occurred. Please try again.");
    }
    setIsLoading(false);
  };

  const navigateToLogin = () => {
    navigate("/login");
  };

  return (
    <>
      {isLoading ? (
        <LoadingOverlay />
      ) : (
        <div className="overlay">
          <div className="confirmation-modal">
            <button className="close-button">&times;</button>
            <div className="modal-content  ">
              <div>
                <img src={emailIcon} alt="Email Icon" className="email-icon " />
              </div>

              <p>{status}</p>
              {/* <p>If you did not get any mail</p> */}
              <button className="resend-button" onClick={navigateToLogin}>
                Back to Log In
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default ConfirmEmail;
